export const environment = {
    production: true,
    baseUrl: 'https://api.sandbox.7thaven.com/v1.0/',
    assetsUrl: "https://admin.sandbox.7thaven.com/assets/",
    kycUrl : "https://kyc.sandbox.7thaven.com/",
    localKey: 'IYOTX3fNxSyOMcrp'
};